export const capitalizeFirstLetter = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const replaceUnderscoreAndCapitalize = (str, from = "_", to = " ") => {
    if(!str) {
        return null;
    }

    return capitalizeFirstLetter(str.toLowerCase()).replaceAll(from, to);
};

export const getPercentColor = (percent) => {
    percent = Number(percent);
    if(percent >= 0 &&  percent <= 40) return "#f56b6b";
    if(percent > 40 &&  percent <= 75) return "#F5B11B";
    if(percent > 75 && percent < 100) return "#F5F52E";
    if(percent === 100) return "#00b67a";
};

export const getTemplateCode = (code) => {
    if(!code) {
        return "No Data";
    }

    const toLower = code.toLocaleLowerCase();
    return (toLower.charAt(0).toUpperCase() + toLower.slice(1)).split("_").join(" ");
};

export const getStepByDate = (date, timePeriodSelected = 60, countDaysForGraph = 5) => {
    let diff;
    const leftDate = new Date();
    const rightDate = new Date();
    rightDate.setDate(rightDate.getDate() + countDaysForGraph);

    if (leftDate <= date && rightDate >= date) {
        const d1 = new Date();
        d1.setHours(0);
        d1.setMinutes(0);
        d1.setSeconds(0);

        const d2 = new Date(date);
        d2.setHours(0);
        d2.setMinutes(0);
        d2.setSeconds(0);

        diff = parseInt(Math.round((d2 - d1) / (60 * 60 * 24 * 1000)));
    } else {
        return -1;
    }
    const countMinutes = date.getHours() * 60 + date.getMinutes();
    const step = Math.floor(countMinutes / timePeriodSelected);
    return parseInt(((diff * 24 * 60) / timePeriodSelected) + step);
};

export const getFormattedDate = (today) => {
    let dd = today.getDate();
    let mm = today.getMonth() + 1;

    let yyyy = today.getFullYear();
    if (dd < 10) {
        dd = "0" + dd;
    }
    if (mm < 10) {
        mm = "0" + mm;
    }
    return dd + "/" + mm + "/" + yyyy;
};

export const getLabelsByType = (x = 60, countDaysForGraph = 5) => {
    const hours = [];
    x = Number(x);
    let tt = 0;
    for (let i = 0; tt < 24 * 60; i++) {
        let hh = Math.floor(tt / 60);
        let mm = (tt % 60);
        hours[i] = ("0" + (hh)).slice(-2) + ":" + ("0" + mm).slice(-2);
        tt = tt + x;
    }
    const today = new Date();

    const times = [];
    for (let i = 0; i <= countDaysForGraph; i++) {
        let dateInTheYear = getFormattedDate(today);
        for (let j in hours) {
            times.push(dateInTheYear + " " + hours[j]);
        }
        today.setDate(today.getDate() + 1);
    }
    const result = [];
    for (let i = 0; i < (times.length - 1); i++) {
        result.push(times[i] + "-" + (times[i + 1]).slice(-5));
    }
    result.push(times[times.length - 1] + "-00:00");

    return result;
};

const getLineColor = (code) => {
    if(code === "MARKETPROTECT"){
        return "#33A1FF";
    }else {
        return "#FFA833";
    }
};

export const buildAll = ({ codes, labels, starts, timePeriod = 60 }) => {
    const data = {};
    for (let j = 0; j < codes.length; ++j) {
        const code = codes[j];
        const dataReceiver = {
            name: code,
            color: getLineColor(code),
            data: []
        };
        for (let i = 0; i < labels.length; ++i) {
            dataReceiver.data.push(0);
        }
        data[code] = dataReceiver;
    }

    codes.forEach((code) => {
        starts[code].forEach((start) => {
            const step = getStepByDate(new Date(start.next_start_at_timestamp), timePeriod);
            if (data[code].data[step] >= 0) {
                data[code].data[step]++;
            }
        });
    });

    return Object.values(data).map((object) => object);
};

export const covertBooleanToYesNo = (state) => (
    state ? "Yes" : "No"
);

export const findDuplicates = arr => {
    const newArr = arr.map((item) => item.toLowerCase());

    return newArr.filter((item, index) => newArr.indexOf(item) !== index);
};

export const not = (a, b) => a.filter(({ code }) => b.indexOf(code) === -1);

export const intersection = (a, b) => a.filter(value => b.some(({ code })=> code.indexOf(value) !== -1));

export const sortAlphabet = (a, b, key = "name") => {
    if(a[key] < b[key]) { return -1; }
    if(a[key] > b[key]) { return 1; }
    return 0;
};

export const percentOneNumberInOther = (first, second) => {
    if(first === 0 && second === 0){
        return 0;
    }

    if(second === 0){
        return 100;
    }

    return Number(100 * (first/second) - 100).toFixed(1);
};

export const templateCodeFormatted = (code) => code.toLowerCase().replaceAll("_", "-");
